module.exports = __webpack_public_path__ + "img/3.abcb982f.png";